import React, {useCallback, useMemo, useState} from 'react'
import {DialogContext} from './dialog-context'

export const DialogProvider = ({children}) => {
    const [dialogs, setDialogs] = useState([])

    const close = useCallback((id) => {
        setDialogs(current => current.filter(dialog => dialog.id !== id))
    }, [])

    const open = useCallback((config) => {
        const id = config?.id || `${Date.now()}-${Math.random()}`
        setDialogs(current => [...current, {...config, id}])
        return id
    }, [])

    const value = useMemo(() => ({dialogs, open, close}), [close, dialogs, open])

    return <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
}
